const allCasesItems = `
    id
    caseId
    created
    productType
    referrer {
        referringPartner
    }
    rentalObject {
        address {
            firstName
            lastName
            streetName
            houseNumber
            apartmentNumber
            district
            postalCode
            city
        }
    }
    profile {
        user {
            phone_number
            email
        }
    }
    path
    status
    inputCompleted
    partitionKey
`;

export default allCasesItems;
